export const filterHTMLBlackColorStyles = (string) => {
    return string.replaceAll('color: rgb(5, 5, 5);', '')
}